module.exports = __webpack_public_path__ + "img/pic-blue.4414bd67.png";